import { ReactNode } from 'react'
import { useGlobalErrorHandler } from '@/hooks/shared/use-global-error-handler'

interface GlobalErrorProviderProps {
  children: ReactNode
  enabled?: boolean
  excludeStatusCodes?: number[]
}

export function GlobalErrorProvider({
  children,
  enabled = true,
  excludeStatusCodes = [401],
}: GlobalErrorProviderProps) {
  useGlobalErrorHandler({
    enabled,
    excludeStatusCodes,
  })

  return <>{children}</>
}
